import type { WorkOrderStatus } from './types';

export const WORK_ORDER_STATUSES: WorkOrderStatus[] = [
  'received',
  'inspected',
  'quoted',
  'approved',
  'in_progress',
  'ready',
  'delivered',
  'invoiced',
  'cancelled',
];

export const WORK_ORDER_STATUS_LABELS: Record<WorkOrderStatus, string> = {
  received: 'Recibido',
  inspected: 'Inspeccionado',
  quoted: 'Cotizado',
  approved: 'Aprobado',
  in_progress: 'En proceso',
  ready: 'Listo',
  delivered: 'Entregado',
  invoiced: 'Facturado',
  cancelled: 'Cancelado',
};

export const WORK_ORDER_STATUS_COLORS: Record<WorkOrderStatus, string> = {
  received: '#6b7280',
  inspected: '#0891b2',
  quoted: '#7c3aed',
  approved: '#2563eb',
  in_progress: '#ea580c',
  ready: '#16a34a',
  delivered: '#0d9488',
  invoiced: '#15803d',
  cancelled: '#dc2626',
};

/** Statuses that count as "active" (not closed). */
export const ACTIVE_WORK_ORDER_STATUSES: WorkOrderStatus[] = [
  'received',
  'inspected',
  'quoted',
  'approved',
  'in_progress',
  'ready',
];

/** Statuses that count as "closed". */
export const CLOSED_WORK_ORDER_STATUSES: WorkOrderStatus[] = [
  'delivered',
  'invoiced',
  'cancelled',
];

export function isClosedStatus(status: WorkOrderStatus): boolean {
  return CLOSED_WORK_ORDER_STATUSES.includes(status);
}

export function isActiveStatus(status: WorkOrderStatus): boolean {
  return ACTIVE_WORK_ORDER_STATUSES.includes(status);
}

/** Valid forward transitions. received → inspected → quoted → approved → in_progress → ready → delivered → invoiced. */
const VALID_TRANSITIONS: Record<WorkOrderStatus, WorkOrderStatus[]> = {
  received: ['inspected', 'quoted', 'cancelled'],
  inspected: ['quoted', 'approved', 'cancelled'],
  quoted: ['approved', 'cancelled'],
  approved: ['in_progress', 'cancelled'],
  in_progress: ['ready', 'cancelled'],
  ready: ['delivered', 'cancelled'],
  delivered: ['invoiced'],
  invoiced: [],
  cancelled: [],
};

export function canTransition(from: WorkOrderStatus, to: WorkOrderStatus): boolean {
  if (from === to) return true;
  return VALID_TRANSITIONS[from]?.includes(to) ?? false;
}

export function nextStatuses(from: WorkOrderStatus): WorkOrderStatus[] {
  return VALID_TRANSITIONS[from] ?? [];
}
